import { createEquipmentCategory, defaultAccessorials } from './internal.ts'

export const bulkEquipment = createEquipmentCategory(
  {
    bucket: 'bulk',
    mode: 'truckload',
    workflows: ['truckload'],
    accessorialTypes: defaultAccessorials,
  },
  [
    { key: 'bulk-aluminum', name: 'Bulk aluminum' },
    { key: 'bulk-auger-semi', name: 'Bulk auger (semi)' },
    { key: 'bulk-auger-straight-truck', name: 'Bulk auger (straight truck)' },
    { key: 'bulk-belt-trailer', name: 'Bulk belt trailer' },
    { key: 'bulk-convertible-hopper', name: 'Bulk convertible hopper' },
    { key: 'bulk-end-dump', name: 'Bulk end dump' },
    { key: 'bulk-hopper', name: 'Bulk hopper' },
    { key: 'bulk-insulated', name: 'Bulk insulated' },
    { key: 'bulk-lined', name: 'Bulk lined' },
    { key: 'bulk-one-tank', name: 'Bulk one tank' },
    { key: 'bulk-pneumatic', name: 'Bulk pneumatic' },
    { key: 'bulk-stainless', name: 'Bulk stainless' },
    { key: 'bulk-two-hole', name: 'Bulk two compartment' },
    { key: 'bulk-three-hole', name: 'Bulk three compartment' },
    { key: 'bulk-four-hole', name: 'Bulk four compartment' },
    { key: 'bulk-walking-floor', name: 'Bulk walking floor' },
    { key: 'bulk-bag-combo', name: 'Bulk bag combo' },
  ],
)
